export const PermissionKey = {
    // Dashboard
    dashboard: 'dashboard',

    // Sales
    sale: 'sale',
    sale_quote: 'sale.quote',
    sale_order: 'sale.order',
    sale_delivery_order: 'sale.delivery_order',
    sale_invoice: 'sale.invoice',
    sale_credit_note: 'sale.credit_note',
    sale_payment: 'sale.payment',
    sale_refund: 'sale.refund',

    // Purchases
    purchase: 'purchase',
    purchase_order: 'purchase.order',
    purchase_goods_received_note: 'purchase.goods_received_note',
    purchase_bill: 'purchase.bill',
    purchase_credit_note: 'purchase.credit_note',
    purchase_payment: 'purchase.payment',
    purchase_refund: 'purchase.refund',

    // Digital Shoebox
    shoebox: 'shoebox',

    // Bank
    bank: 'bank',
    bank_income: 'bank.income',
    bank_expense: 'bank.expense',
    bank_transfer: 'bank.transfer',
    bank_account: 'bank.account',
    bank_feed: 'bank.feed',

    // Contact
    contact: 'contact',
    contact_customer: 'contact.customer',
    contact_supplier: 'contact.supplier',
    contact_employee: 'contact.employee',

    // Product
    product: 'product',
    product_item: 'product.item',
    product_group: 'product.group',
    product_bundle: 'product.bundle',

    // Stock
    stock: 'stock',
    stock_adjustment: 'stock.adjustment',
    stock_transfer: 'stock.transfer',
    stock_value: 'stock.value',

    // MyInvois
    myinvois: 'myinvois',

    // Reports
    report: 'report',

    // Report - Financial Reports
    report_balance_sheet: 'report.balance_sheet',
    report_profit_loss: 'report.profit_loss',
    report_cash_flow: 'report.cash_flow',
    report_financial_summary: 'report.financial_summary',

    // Report - Aged Reports
    report_aged_receivable: 'report.aged_receivable',
    report_aged_payable: 'report.aged_payable',

    // Report - Sales Reports
    report_invoice_summary: 'report.invoice_summary',
    report_sale_credit_note_summary: 'report.sale_credit_note_summary',
    report_sale_payment_summary: 'report.sale_payment_summary',
    report_sale_quote_by_customer: 'report.sale_quote_by_customer',
    report_sale_order_by_customer: 'report.sale_order_by_customer',
    report_sale_delivery_order_by_customer: 'report.sale_delivery_order_by_customer',
    report_sale_by_customer: 'report.sale_by_customer',
    report_sale_by_tag: 'report.sale_by_tag',

    // Report - Purchase Reports
    report_bill_summary: 'report.bill_summary',
    report_purchase_credit_note_summary: 'report.purchase_credit_note_summary',
    report_purchase_payment_summary: 'report.purchase_payment_summary',
    report_purchase_order_by_supplier: 'report.purchase_order_by_supplier',
    report_purchases_by_supplier: 'report.purchases_by_supplier',

    // Reports - Payment Reports
    report_official_receipt_summary: 'report.official_receipt_summary',
    report_payment_voucher_summary: 'report.payment_voucher_summary',
    report_cash_sales_summary: 'report.cash_sales_summary',
    report_cash_purchase_summary: 'report.cash_purchase_summary',

    // Reports - Product Reports
    report_product_sale: 'report.product_sale',
    report_product_bundle_sale: 'report.product_bundle_sale',
    report_product_purchase: 'report.product_purchase',
    report_item_sales_collection: 'report.item_sales_collection',

    // Reports - Inventory Reports
    report_inventory: 'report.inventory',
    report_profit_summary: 'report.profit_summary',
    report_profit_detail: 'report.profit_detail',

    // Reports - Fixed Asset Reports
    report_asset: 'report.asset',

    // Reports - Ledger Reports
    report_general_ledger: 'report.general_ledger',
    report_debtor_ledger: 'report.debtor_ledger',
    report_creditor_ledger: 'report.creditor_ledger',

    // Reports - SST Reports
    report_sst: 'report.sst',

    // Accounting Reports
    report_journal_entry_detail: 'report.journal_entry_detail',
    report_double_entry_detail: 'report.double_entry_detail',
    report_trial_balance: 'report.trial_balance',
    report_bank_reconciliation: 'report.bank_reconciliation',
    report_transaction_list: 'report.transaction_list',
    report_exchange_gain_loss: 'report.exchange_gain_loss',
    report_exchange_rates: 'report.exchange_rates',
    report_audit_trail: 'report.audit_trail',
    report_chart_of_accounts: 'report.chart_of_accounts',

    reports_all: 'reports_all', // Special Permission that checks for other reports

    // Accounting
    accounting: 'accounting',
    accounting_journal_entry: 'accounting.journal_entry',
    accounting_contra: 'accounting.contra',
    accounting_fixed_asset: 'accounting.fixed_asset',
    accounting_deemed_payment: 'accounting.deemed_payment',
    accounting_chart_of_account: 'accounting.chart_of_account',

    // Flow
    flow: 'flow',

    // Control Panel
    control_panel: 'control_panel',
    cp_app: 'control_panel.app',
    cp_instruction: 'control_panel.instruction',
    cp_payment_term: 'control_panel.payment_term',
    cp_payment_method: 'control_panel.payment_method',
    cp_form_design: 'control_panel.form_design',
    cp_price_level: 'control_panel.price_level',
    cp_currency: 'control_panel.currency',
    cp_asset_type: 'control_panel.asset_type',
    cp_location: 'control_panel.location',
    cp_number_format: 'control_panel.number_format',
    cp_custom_field: 'control_panel.field',
    cp_tag: 'control_panel.tag',
    cp_company_profile: 'control_panel.company_profile',
    cp_company_setting: 'control_panel.company_setting',
    cp_flow_setting: 'control_panel.flow_setting',
    cp_shoebox_setting: 'control_panel.shoebox_setting',
    cp_integration: 'control_panel.integration',
    cp_backup_data: 'control_panel.backup_data',

    // Bukku Store Settings
    store: 'store',

    // Financing Portal
    financing: 'financing',

    manage_users: 'manage_users', // permission
    manage_billing: 'manage_billing', // permission
    partners: 'partners', //

    minipos: 'minipos',
    //Bukku Admin
    bukkuadmin: 'bukkuadmin',

    null: null,
};
